import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Language } from '../../../../lib/Enums/Language'
import { Budget } from '../../../../lib/Types'
import * as AIAPI from '../API/AIAPI'
import { ChatMessage, ChatUsage } from '../API/AIAPI'

interface SendChatArgs {
  messages: ChatMessage[]
  onToken: (token: string) => void
  language: Language
}

interface CompleteChatArgs {
  budget: unknown
  usage?: ChatUsage
  messages?: ChatMessage[]
}

export const useSendChat = () => {
  return useMutation({
    mutationFn: ({ messages, onToken, language }: SendChatArgs) =>
      AIAPI.streamChat(messages, onToken, language),
  })
}

export const useCompleteChat = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ budget, usage, messages }: CompleteChatArgs) =>
      AIAPI.completeChat(budget, usage, messages),
    // /complete/ returns the created budget, so add it to the list cache
    // (mirrors useCreateBudget) so it shows up on the dashboard without a reload.
    onSuccess: (budget: Budget) => {
      const existing = queryClient.getQueryData<Budget[]>(['budgets'])
      if (existing) {
        queryClient.setQueryData(['budgets'], [...existing, budget])
      } else {
        // No list cached yet — let it fetch fresh when the dashboard mounts.
        queryClient.invalidateQueries({ queryKey: ['budgets'] })
      }
      queryClient.invalidateQueries({ queryKey: ['task'] })
    },
  })
}
